<app-standard-page>
  <app-standard-page-content [limitWidth]="true">
    <app-standard-page-content-grid>
      @if (isLoaded) {
        @if (!isRedeemable) {
          <app-alert type="danger">
            <p>{{ isRedeemableMessage }}</p>
            <p>
              <a
                data-dd-action-name="azure-market-place.continue-setup-link"
                routerLink="/create-organisation"
                >Continue setting up my account</a
              >
            </p>
          </app-alert>
        }
      } @else {
        <app-loading
          message="Setting up FinQuery Fixed Assets From Microsoft Market Place..."
        ></app-loading>
      }
    </app-standard-page-content-grid>
  </app-standard-page-content>
</app-standard-page>
